export const toNumber = (value: any) => Number(value || 0);